import React, { Component, Fragment } from 'react'
import { AddFriends } from './FriendsSidebar'
import FriendLabel from './FriendLabel'
import { Action } from '@foodsby/nutrient'

const DEFAULT_VIEWABLE_FRIENDS = 3

export const FriendsNotOrderedYetPanel = ({
  friendCount,
  friendNotOrdered,
  showMore,
  showDivider,
  handleClick,
  isWebpSupported,
}) => (
  <Fragment>
    {friendNotOrdered.length === 0 ? (
      <h4 className="center-xs">All of your friends have ordered today!</h4>
    ) : (
      <Fragment>
        <div className="friendsTitle">
          <i className="icon-users" />
          <strong> Haven't Ordered</strong>
        </div>
        <div className="row friendsRow">
          {friendNotOrdered &&
            friendNotOrdered
              .slice(0, showMore ? friendCount : DEFAULT_VIEWABLE_FRIENDS)
              .map((friendsOrder, i) => (
                <FriendLabel
                  avatarId={friendsOrder.friend.avatarId}
                  email={friendsOrder.friend.email}
                  firstName={friendsOrder.friend.firstName}
                  friendLabelClasses="col-xs-6 col-sm-4 middle-xs"
                  isWebpSupported={isWebpSupported}
                  key={i}
                  lastName={friendsOrder.friend.lastName}
                  showEmail={false}
                />
              ))}
        </div>
        {friendCount > DEFAULT_VIEWABLE_FRIENDS && (
          <div className="row center-xs">
            <Action id="showMoreButton" onClick={handleClick}>
              {showMore
                ? 'Show Less'
                : 'Show More (' +
                  (friendCount - DEFAULT_VIEWABLE_FRIENDS) +
                  ')'}
            </Action>
          </div>
        )}
      </Fragment>
    )}
  </Fragment>
)

export default class FriendsPanel extends Component {
  state = { showMore: false }

  handleClick = () => {
    this.setState(prevState => ({
      showMore: !prevState.showMore,
    }))
  }

  render() {
    const { friends, friendNotOrdered, isWebpSupported } = this.props
    return (
      <div className="friendsPanelContainer">
        {friends && friendNotOrdered && (
          <Fragment>
            <FriendsNotOrderedYetPanel
              friendCount={friendNotOrdered.length}
              friendNotOrdered={friendNotOrdered}
              handleClick={this.handleClick}
              isWebpSupported={isWebpSupported}
              showMore={this.state.showMore}
            />
          </Fragment>
        )}
        <AddFriends />
      </div>
    )
  }
}
